import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox} from 'carbon-components-react';


const FormCheckbox = ({label, name, id, disabled, setChecked, onChange, props,shouldUncheck}) => {
    const {register,formState,setValue, watch, trigger} = useFormContext(); 
    const [objValue, setObjValue] = useState(false); 
    const watcher = watch(name);

    if(!setChecked)
    {
        setChecked = () =>{
        }        
    }

    if(!id){
        id = `chk-${name}`;
    }

    let obj = formState.errors[name];

    const array = name.substr(0, name.indexOf("["));
    const refreshObj = () => {
        if(array.length > 0){
            const optionalName = name.replace('.', '?.');
            obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null;
        }
    }
    
 
    useEffect(() => {
        if(typeof watcher == "boolean"){
            setObjValue(watcher);
            setChecked(watcher);
            setValue(name, watcher);
            trigger(name);
            if (shouldUncheck === true){
                setValue(name,false);
                setObjValue(false);
                setChecked(false);
            }
        }

        refreshObj();

    }, [watcher,shouldUncheck]);

    const change = (e) => {
        
            setValue(name, e);
            setObjValue(e);
            setChecked(e);
        
        if(onChange)
            onChange(e);
     
    }

    return (  
        <>
        <Checkbox id={id} labelText={label} {...register(name)}
            onChange={change}
            disabled={disabled}
            checked={objValue}
            {...props} 
        />

        </>
    );
}
 
export default FormCheckbox;